import { render } from "./SelectionForm.vue?vue&type=template&id=c84a3f86"
import script from "./SelectionForm.vue?vue&type=script&lang=js"
export * from "./SelectionForm.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__